<!-- Composant commentaire avec toolbar Quill intégrée -->
<div class="new-comment py-2 px-2">
    <div class="custom-new-comment">
        <p-avatar
            [image]="currentUser.pictureReference"
            styleClass="comment-profile-picture avatar"
            size="large"
            shape="circle"
            [style]="{ 'background-color': 'var(--club-gray-light)' }"
            [label]="!currentUser.pictureReference ? currentUser.firstName.slice(0, 1) + currentUser.lastName.slice(0, 1) : ''"
        ></p-avatar>

        <div class="custom-new-comment-input">
            <quill-editor
                class="w-100 border-rounded-2"
                #newCommentQuillEditor
                id="content"
                [formControl]="form.controls.content"
                placeholder="{{ 'clubs.page.common.card.addComment.text' | translate }}"
                theme="snow"
                [modules]="commentQuillEditorHelper.modulesForCommentsPosts"
                [formats]="quillEditorHelper.formats"
                (paste)="handlePaste($event)"
                [mention]="members"
                [mentionConfig]="{ dropUp: false }"
                (mentionSelectedEvent)="onMentionSelected($event)"
                (opened)="onMentionListOpen()"
                (closed)="onMentionListClosed()"
                (keydown)="onKeydown($event)"
                (dragover)="handleDragOver($event)"
                (dragenter)="handleDragEnter($event)"
                (drop)="handleDrop($event)"
                (textChange)="onWritting()"
            ></quill-editor>

            <div class="action-buttons-container" style="position: absolute; top: 8px; left: 192px">
                <!-- Emoji button -->
                <button
                    pButton
                    pRipple
                    type="button"
                    icon="icon-o-smile"
                    class="p-button-rounded p-button-text p-button-plain"
                    pTooltip="{{ 'clubs.page.common.card.addComment.emoji' | translate }}"
                    tooltipPosition="top"
                    (click)="handleEmojiPickerButtonClick()"
                ></button>

                <!-- Image button -->
                <input
                    [formControl]="form.controls.image"
                    #imageInput
                    type="file"
                    accept="image/*"
                    style="display: none"
                    (change)="updateImage($event)"
                />
                <button
                    pButton
                    pRipple
                    type="button"
                    icon="icon-picture"
                    class="p-button-rounded p-button-text p-button-plain"
                    pTooltip="{{ 'clubs.page.common.card.addComment.image' | translate }}"
                    tooltipPosition="left"
                    (click)="imageInput.click()"
                ></button>
                <div #emojiPicker class="emoji-container" *ngIf="isEmojiPickerVisible">
                    <emoji-mart
                        class="emoji-picker-container"
                        title="{{ 'clubs.page.common.card.addComment.selectEmoji' | translate }}"
                        [darkMode]="false"
                        [i18n]="emojiTranslations"
                        [skin]="2"
                        [isNative]="true"
                        color="var(--bs-primary)"
                        [hideObsolete]="false"
                        [showPreview]="false"
                        [showSingleCategory]="true"
                        (emojiSelect)="addEmojiToContent($event)"
                    ></emoji-mart>
                </div>
            </div>
        </div>
    </div>

    <!-- Compteur de caractères -->
    <div class="length-information" *ngIf="contentLength > 0">{{ contentLength }}/{{ PUBLICATION_CONTENT_MAX_LENGTH }}</div>

    <!-- Emoji picker -->

    <!-- Container d'images -->
    <div class="image-container" *ngIf="localImageSrc">
        <image-cropper-old
            [format]="'png'"
            [imageChangedEvent]="imageService.imageChangedEvent"
            [imageBase64]="localImageSrc"
            [imageURL]="cropperParams.urlImage"
            [maintainAspectRatio]="cropperParams.isRatioFix"
            [containWithinAspectRatio]="imageService.containWithinAspectRatio"
            [aspectRatio]="cropperParams.ratio"
            [cropperMinWidth]="cropperParams.minWidth"
            [cropperMinHeight]="cropperParams.minHeight"
            [onlyScaleDown]="true"
            [roundCropper]="false"
            [canvasRotation]="imageService.canvasRotation"
            [alignImage]="cropperParams.alignImage"
            [resizeToWidth]="cropperParams.resizeToWidth"
            [resizeToHeight]="cropperParams.resizeToHeight"
            (imageCropped)="imageHasBeenCropped($event)"
            (imageLoaded)="imageService.imageLoaded()"
            (loadImageFailed)="imageService.loadImageFailed()"
        ></image-cropper-old>
        <button class="remove-button" (click)="handleRemoveImage()">
            <i class="pi pi-times"></i>
        </button>
    </div>

    <!-- Messages d'erreur -->
    <div *ngIf="form.controls.content.invalid && (form.controls.content.dirty || form.controls.content.touched)">
        <div class="danger-text" *ngIf="form.controls.content.errors?.['maxlength']">
            {{
                'clubs.page.tabs.discussion.post.textLengthValidator'
                    | translate : { publicationContentMaxLength: PUBLICATION_CONTENT_MAX_LENGTH, currentTextLength: contentLength }
            }}
        </div>
    </div>

    <!-- Bouton de publication -->
    <div class="custom-publish-comment-button" *ngIf="form.controls.content.value || form.value.picture || shouldDisplayButton">
        <p-button
            label="{{ 'components.button.publish' | translate }}"
            (click)="addComment()"
            [disabled]="!form.valid"
            styleClass="btn-sm"
        ></p-button>
    </div>
</div>
